
export const ON_APPSETTINGS_SUCCESS = 'ON_APPSETTINGS_SUCCESS';

